<template>
  <div class="login-container">
    <div class="login-box bg-white radius-20 w-520 padding-bottom-40">
      <div class="text-center padding-top-40 padding-bottom-30 text-bold text-main text-32">注册</div>
      <el-form ref="registerForm" :model="registerForm" :rules="registerRules" class="login-form w-450" label-width="0">
        <el-form-item prop="mobile">
          <el-input v-model="registerForm.mobile" placeholder="手机号输入" size="large" class="custom-input"
            @keyup.enter.native="handleSubmit">
            <template slot="prefix">
              <img :src="icon1" alt="icon" class="input-icon" />
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="email">
          <el-input v-model="registerForm.email" placeholder="邮箱输入" size="large" class="custom-input"
            @keyup.enter.native="handleSubmit">
            <template slot="prefix">
              <img :src="icon2" alt="icon" class="_input-icon" />
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input v-model="registerForm.code" placeholder="验证码" size="large" class="custom-input code-input"
            @keyup.enter.native="handleSubmit">
            <template slot="prefix">
              <img :src="icon3" alt="icon" class="input-icon" />
            </template>
            <template slot="suffix">
              <el-button :disabled="countdown > 0" type="text" class="get-code-btn text-main text-bold"
                @click="getVerificationCode">
                {{ countdown > 0 ? `${countdown}秒后重新获取` : '获取验证码' }}
              </el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="registerForm.password" type="password" placeholder="请输入密码" size="large"
            class="custom-input" show-password @keyup.enter.native="handleSubmit">
            <template slot="prefix">
              <img :src="icon3" alt="icon" class="input-icon" />
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="invite_code">
          <el-input v-model="registerForm.invite_code" placeholder="邀请码" size="large" class="custom-input"
            @keyup.enter.native="handleSubmit">
            <template slot="prefix">
              <img :src="icon3" alt="icon" class="input-icon" />
            </template>
          </el-input>
        </el-form-item>
        <el-button type="primary" size="large" :loading="loading" class="login-button radius-100 bg-main margin-top-10"
          @click="handleSubmit">
          {{ loading ? '注册中...' : '注册' }}
        </el-button>
        <div class="text-main text-center padding-top-20 login-link" @click="goToLogin">
          已有账户去登录
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { sendSmsCode, register } from '@/api/user';

export default {
  name: 'Register',
  data() {
    // 自定义手机号验证规则
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'));
      } else {
        const phoneReg = /^1[3-9]\d{9}$/;
        if (!phoneReg.test(value)) {
          callback(new Error('请输入正确的手机号格式'));
        } else {
          callback();
        }
      }
    };

    // 自定义邮箱验证规则
    const validateEmail = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入邮箱'));
      } else {
        const emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailReg.test(value)) {
          callback(new Error('请输入正确的邮箱格式'));
        } else {
          callback();
        }
      }
    };

    // 自定义验证码验证规则
    const validateCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入验证码'));
      } else if (value.length < 4) {
        callback(new Error('验证码长度不能少于4位'));
      } else {
        callback();
      }
    };

    // 自定义密码验证规则
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'));
      } else if (value.length < 6) {
        callback(new Error('密码长度不能少于6个字符'));
      } else {
        callback();
      }
    };

    // 自定义邀请码验证规则
    const validateInviteCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入邀请码'));
      } else {
        callback();
      }
    };

    return {
      checked: false,
      icon1: require('@/assets/images/icon1.png'),
      icon3: require('@/assets/images/icon3.png'),
      icon2: require('@/assets/images/icon2.png'),
      countdown: 0,
      countdownTimer: null,
      registerForm: {
        mobile: '',
        email: '',
        code: '',
        password: '',
        invite_code: ''
      },
      registerRules: {
        mobile: [
          { validator: validateMobile, trigger: 'blur' }
        ],
        email: [
          { validator: validateEmail, trigger: 'blur' }
        ],
        code: [
          { validator: validateCode, trigger: 'blur' }
        ],
        password: [
          { validator: validatePassword, trigger: 'blur' }
        ]
      },
      loading: false
    };
  },
  methods: {
    // 获取验证码
    getVerificationCode() {
      // 验证手机号是否填写
      if (!this.registerForm.mobile) {
        this.$message.warning('请先输入手机号');
        return;
      }

      // 验证手机号格式
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!phoneReg.test(this.registerForm.mobile)) {
        this.$message.warning('请输入正确的手机号格式');
        return;
      }

      // 如果正在倒计时，不允许重复点击
      if (this.countdown > 0) {
        return;
      }

      // 调用发送验证码接口
      sendSmsCode(this.registerForm.mobile, 'register')
        .then(response => {
          this.$message.success('验证码已发送');
          // 开始倒计时
          this.countdown = 60;
          this.countdownTimer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              clearInterval(this.countdownTimer);
              this.countdownTimer = null;
            }
          }, 1000);
        })
        .catch(error => {
          this.$message.error(error.message || '验证码发送失败，请稍后重试');
        });
    },
    handleSubmit() {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          // 调用注册接口
          register({
            mobile: this.registerForm.mobile,
            email: this.registerForm.email,
            password: this.registerForm.password,
            code: this.registerForm.code,
            invite_code: this.registerForm.invite_code
          })
            .then(response => {
              this.loading = false;
              this.$message.success('注册成功！');
              // 注册成功后跳转到登录页
              setTimeout(() => {
                this.$router.push('/login');
              }, 1500);
            })
            .catch(error => {
              this.loading = false;
              this.$message.error(error.message || '注册失败，请稍后重试');
            });
        } else {
          this.$message.error('请填写完整的信息');
          return false;
        }
      });
    },
    goToLogin() {
      this.$router.push('/login');
    }
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  }
};
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100vh;
  background-image: url('@/assets/images/login.png');
  background-size: 100% 100%;
}

.login-box {
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  animation: slideIn 0.5s ease-out;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}


.login-form {
  margin: 0 auto;
}

.login-form .el-form-item {
  margin-bottom: 22px;
}

.custom-input {
  width: 450px;
  height: 62px;
}

.custom-input /deep/ .el-input__inner {
  width: 450px;
  height: 62px;
  line-height: 62px;
  padding-left: 55px;
}

.code-input /deep/ .el-input__inner {
  padding-right: 120px;
}

.get-code-btn {
  padding: 0 10px;
  height: 100%;
  border: none;
  background: transparent;
}

.get-code-btn:hover {
  background: transparent;
}

.get-code-btn:disabled {
  color: #999;
}

.custom-input /deep/ .el-input__prefix {
  left: 20px;
}

.input-icon {
  width: 17px;
  height: 20px;
  margin-top: 21px;
}

._input-icon {
  width: 20px;
  height: 15px;
  margin-top: 23px;
}

.login-button {
  width: 450px;
  height: 61px;
  border: none;
}

.login-link {
  cursor: pointer;
}
</style>
